<template>
  <v-dialog v-model="dialog" width="900" @click:outside="() => $emit('onCloseDialog')">
    <v-card>
      <v-card-title class="header">
        <div class="d-flex justify-space-between" style="width: 100%">
          <span>{{ 'Xem trước' }}</span>
          <v-icon color="white" @click="() => closeDialog()">mdi-close</v-icon>
        </div>
      </v-card-title>
      <v-card-text>
        <div class="data-table mt-4">
          <v-data-table
            disable-sort
            :headers="headers"
            :items="items"
            :footer-props="{
              'items-per-page-text': 'Số dữ liệu mỗi trang',
              'items-per-page-options': [5, 10, 20]
            }"
          >
            <template v-slot:[`item.deliveredAt`]="{ item }">
              <span>{{ item.deliveredAt }}</span>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
      <v-divider class="mt-4"></v-divider>
      <v-card-actions>
        <v-btn color="error" outlined @click="() => closeDialog()">{{ 'Huỷ' }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="() => $emit('onSave')">{{ 'Lưu' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDateDDMMYYYY } from '@/helpers/date.js'
export default {
  data() {
    return {
      headers: [
        { text: 'Mã kho', value: 'name_short', width: '15%' },
        { text: 'Tên kho', value: 'name', width: '20%' },
        { text: 'Model', value: 'code', width: '15%' },
        { text: 'Mô tả', value: 'description', width: '30%' },
        { text: 'Số lượng', value: 'quantity', width: '10%', align: 'end' },
        { text: 'Ngày nhập', value: 'deliveredAt', width: '10%', align: 'end' }
      ],
      dialog: false,
      items: []
    }
  },
  methods: {
    formatDateDDMMYYYY: formatDateDDMMYYYY,
    openDialog(data) {
      if (Array.isArray(data) && data.length) this.items = data
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.$emit('onCloseDialog')
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  background-color: #014380;
  color: white;
}

.data-table {
  height: 65vh;
  overflow: auto;
}
</style>
